<template>
  <MainLayout>
    <template v-slot:mainView>
      <router-view />
    </template>
  </MainLayout>
</template>
<script>
import MainLayout from "./views/layouts/MainLayout.vue";
import gql from "graphql-tag";
import { useToast } from 'vue-toastification';
import { corevasAxios } from './corevas'
import { AUTH_TOKEN_KEY } from './constants'

export default {
  name: "App",
  components: {
    MainLayout,
  },

  setup() {
      const toast = useToast()

    return {
      toast
    }
  },

  mounted() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.u) {
      this.$store.commit("SET_TOKEN", params.u);
      this.getCurrentUserInfo();
      //this.$router.push('/');
      // The operator redirect already lands on /thank-you; only navigate
      // when we arrived somewhere else (e.g. a stale tab).
      if (this.$route.path !== '/thank-you') {
        this.$router.push('/thank-you');
      }
    }

    if(this.$store.getters.getToken) {
      this.getCurrentUserInfo();
    }
  },

  methods: {
    getCurrentUserInfo() {
      const token = localStorage.getItem(AUTH_TOKEN_KEY)
      if (!token) return

      // Corevas (the unified MVAS platform) issued the token, so it is the
      // authority on who the user is and whether they are subscribed. The
      // legacy GraphQL me below only enriches app-specific extras (display
      // name, notifications) and may fail while the backend is still on
      // pre-corevas code.
      corevasAxios
        .get('auth/me', {
          params: { service: process.env.VUE_APP_COREVAS_SERVICE },
          headers: { Authorization: 'Bearer ' + token, Accept: 'application/json' },
        })
        .then((response) => {
          const me = response.data && response.data.data
          if (!me) return

          const svc = (me.services || []).find((s) => s.slug === process.env.VUE_APP_COREVAS_SERVICE)
          const operator = (me.operator || '').startsWith('mtn') ? 'MTN'
            : (me.operator || '').startsWith('sudani') ? 'Sudani' : 'Zain'

          this.$store.commit('SET_USER', {
            id: me.id,
            name: me.phone,
            phone: me.phone,
            is_subscribed: svc ? svc.status === 'active' : !!me.is_subscribed,
            unreadNotificationsCount: 0,
            subscription_model: {
              id: null,
              operator,
              active_billing_until: (svc && svc.expires_at) || me.active_billing_until || null,
              has_active_billing: svc ? !!svc.has_active_billing : !!me.has_active_billing,
            },
          })
        })
        .catch(() => {})

      this.$apollo
        .query({
          query: gql`
            query {
              me {
                id
                name
                phone

                unreadNotificationsCount

                subscription_model {
                  id
                  operator
                  active_billing_until
                  has_active_billing
                }
              }
            }
          `,
        })
        .then((data) => {
          // Enrichment only (display name + notifications); the subscription
          // state set from corevas above stays authoritative.
          const current = JSON.parse(localStorage.getItem(AUTH_USER_KEY)) || {}
          this.$store.commit('SET_USER', { ...current, ...data.data.me })
          this.$store.commit('UPDATE_UNREAD_NOTIFICATIONS_COUNT', data.data.me?.unreadNotificationsCount)
        })
        .catch(() => {})
    },

    reportError(error) {
      let { graphQLErrors } = error;

      if (graphQLErrors[0].extensions.category === "authentication") {
        this.$router.push({ name: 'Profile' })
      }
    }
  },
};
</script>

<style lang="scss">
///
</style>
